import OrganizationDestroyModal from "./OrganizationDestroyModal"

export default OrganizationDestroyModal
